<template>
  <div id="ScoreRanking">
    <div class="userInfo-box">
      <!-- <van-nav-bar
        title="积分排名"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      /> -->
      <div class="score"><img src="@/assets/images/scroebg.png" /></div>

      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell class="leftcancel">
          <div class="vancel">
            <div class="vancel-wrap">
            <div class="rank-point">
              <img
                src="@/assets/images/one.png"
                class="tieimages"
                v-if="listTop.rank == 1"
              />
              <img
                src="@/assets/images/two.png"
                class="tieimages"
                v-if="listTop.rank == 2"
              />
              <img
                src="@/assets/images/there.png"
                class="tieimages"
                v-if="listTop.rank == 3"
              />
              <span v-if="listTop.rank !== 1 && listTop.rank !== 2 && listTop.rank !== 3">
                {{ listTop.rank }}.
              </span>
            </div>
             <div class="entname">{{ listTop.entName }}</div>
             </div>
            <div :class="listTop.rank<=3?'redcolor':'' ">{{ listTop.totalPoint }}</div>
          </div>
        </van-cell>
        <van-cell v-for="(item, index) in list" :key="index">

          <div class="vancel">
            <div class="vancel-wrap">
            <div class="rank-point">
            <img
              src="@/assets/images/one.png"
              class="tieimages"
              v-if="item.rank == 1"
            />
            <img
              src="@/assets/images/two.png"
              class="tieimages"
              v-if="item.rank == 2"
            />
            <img
              src="@/assets/images/there.png"
              class="tieimages"
              v-if="item.rank == 3"
            />
            <span v-if="item.rank !== 1 && item.rank !== 2 && item.rank !== 3">
              {{ index + 1 }}.
            </span>
          </div>
             <div class="entname">{{ item.ent_name }}</div>
            </div>
            <div :class="item.rank<=3?'redcolor':''" >{{ item.total_point }}</div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import { pointEntRank } from '@api/lishui/integral'
import { getLocalStorage, setLocalStorage, removeLocalStorage } from '@utils'
export default {
  name: 'ScoreRanking',
  props: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      pageSize: 20,
      pageNum: 1,
      listTop: {}
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onLoad() {
      const params = {
        creditCode: this.userInfo.creditCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      pointEntRank(params).then(res => {
        if (res.data.code === '0000') {
          this.loading = false
          const listData = res.data.data.results
          if (listData.length === 0) {
            this.finished = true
          } else {
            this.finished = false
            this.pageNum++
          }
          for (var i = 0; i < listData.length; i++) {
            this.list.push(listData[i])
          }
          this.listTop = res.data.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.score {
  margin-bottom:-9px;
  img {
    width: 100%;
    height: 90px;
  }
}
.tieimages {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.vancel {
  display: flex;
  justify-content: space-between;
}
.vancel-wrap{
  display: flex;
  span{
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
  }
}
.entname {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  padding-right:20px;
  padding-left:10px;
}
.redcolor{
  color: #FA7E40;
  font-size: 16px;
}
.leftcancel{
  margin-bottom:9px;
  border-bottom:10px solid #eee;
}
</style>
